import {
  AutonomyGroup,
  type AutonomyGroup as AutonomyGroupType,
} from '@kirin/api-client/contracts/autonomous-execution';

/* KIR-4024: tooltip text for the "Auto Mode ON" badge (AutoModeBadge). */

/** Tooltip for one user's Claude Code chip. */
export function autoModeUserTooltip(group: AutonomyGroupType): string {
  return group === AutonomyGroup.Yolo
    ? 'Claude Code runs with every permission check skipped (bypass permissions), or is set to start that way.'
    : 'Claude Code runs in auto mode, or is set to start in it.';
}

/** Tooltip for a Claude Code row in Installed AI Tools. */
export function autoModeToolTooltip(userCount: number): string {
  return userCount === 1
    ? '1 user runs Claude Code in auto mode or YOLO mode.'
    : `${userCount} users run Claude Code in auto mode or YOLO mode.`;
}
